var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserGender = function SvgUserGender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.106 7.247a1.2 1.2 0 0 0-.22 0 2.947 2.947 0 0 1-2.847-2.954 2.95 2.95 0 0 1 2.953-2.96 2.96 2.96 0 0 1 2.96 2.96c0 1.6-1.266 2.9-2.846 2.954M7.993 14.54c-1.213 0-2.42-.307-3.34-.92-1.613-1.08-1.613-2.84 0-3.913 1.834-1.227 4.84-1.227 6.674 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "m13.334 10.667-1.543 1.543m1.543-1.543h-1.429m1.429 0v1.428m-4 1.143a1.428 1.428 0 1 0 2.857 0 1.428 1.428 0 0 0-2.857 0"
  })));
};
export default SvgUserGender;